import React from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../redux/store'
import { fetchLogout } from '../../redux/authSlice';

export const LogoutButton = () => {
    const dispatch = useDispatch();

    const logoutHandler = () => {
        dispatch(fetchLogout());
    }
  return (
    <div onClick={logoutHandler} className='logout pointer'>Выйти</div>
  )
}